export default __webpack_public_path__ + "static/media/2.41f8e525.jpg";